// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"71ffffff","354":"71ffffff","367":"453f951d","433":"eaaf386c","466":"f00a56d7","588":"71ffffff","759":"5f9f0c4c","961":"a0e0497b"}[chunkId] + ".css";
};